import { snackbarDurations } from '@manager/modules/snackbar/snackbar-config';
import type {
  INotificationOptions,
  INotificationType,
  ISnackbarItem,
} from '@manager/modules/snackbar/snackbar-types';

const variantClasses: Record<INotificationType, string> = {
  success: 'bg-green-50 border border-green-200',
  error: 'bg-red-50 border border-red-200',
  info: 'bg-blue-50 border border-blue-200',
};

export function createSnackbarItem(
  text: string,
  options: INotificationOptions
): ISnackbarItem {
  const type = options.type ?? 'success';

  return {
    type,
    text,
    timeout: options.duration,
    showClose: options.showButton,
    contentClass: `app-snackbar ${variantClasses[type]}`,
    link: options.link,
  };
}

export function getDefaultNotificationOptions(
  type: INotificationType
): INotificationOptions {
  return {
    type,
    duration: snackbarDurations[type],
    showButton: true,
  };
}
